import React from 'react';
import { Helmet } from 'react-helmet';
import AuthenticationLayout from './components/AuthenticationLayout';
import EmailForm from './components/EmailForm';

const EmailAuthenticationEntry = () => {
  return (
    <>
      <Helmet>
        <title>ورود به سیستم - ایران‌داد</title>
        <meta
          name="description"
          content="ورود به سیستم مشاوره حقوقی آنلاین با ربات هوشمند فارسی"
        />
        <meta
          name="keywords"
          content="مشاوره حقوقی, ایران‌داد , ورود, احراز هویت"
        />
        <meta property="og:title" content="ورود به سیستم -  ایران‌داد" />
        <meta
          property="og:description"
          content="دسترسی به مشاوره حقوقی فوری با ربات هوشمند"
        />
        <meta property="og:type" content="website" />
        <link rel="canonical" href="/email-authentication-entry" />
      </Helmet>

      <AuthenticationLayout>
        <EmailForm />
      </AuthenticationLayout>
    </>
  );
};

export default EmailAuthenticationEntry;
